import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { db_tables, routes } from '@app/consts';
import { modules } from '@app/consts/modules';
import { ModuleConfigurationService } from '@app/core/services/module-configuration/module-configuration.service';
import { TablePermissionsService } from '@app/core/services/table-permissions/table-permissions.service';
import { EmployeeTableSecurity } from '@app/shared/models/employee.model';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { Location } from '@angular/common';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss']
})
export class EmployeeDetailsComponent implements OnInit {
  @Input() subSection: string = 'PersonalDetails';
  public routes: typeof routes = routes;
  employeeId: string;

  navList = [];
  public db_tables = db_tables;
  targetEmployeeTablePermissions: EmployeeTableSecurity[];
  isLoading: boolean = true;
  // selectedComponent = this.translate.instant('PersonalDetails');
  searchText: string;

  constructor(
    public translate: TranslateService,
    public router: Router,
    private route: ActivatedRoute,
    private tablePermissionsService: TablePermissionsService,
    private moduleConfigurationService: ModuleConfigurationService,
    private location: Location
  ) {
    this.employeeId = this.getIdInURL();
    this.getTargetEmployeeTablePermissions();
  }

  ngOnInit(): void { }

  getIdInURL(): string {
    let IdInURL: string;

    this.route.paramMap.subscribe(
      params => IdInURL = params.get("id")
    )

    return IdInURL;
  }

  getSubSectionFromURL(): string {
    let subSectionInURL: string;
    this.route.paramMap.subscribe(
      params => subSectionInURL = params.get("subSection")
    )
    return subSectionInURL;
  }

  getTargetEmployeeTablePermissions() {
    this.isLoading = true;

    this.tablePermissionsService.getTargetEmployeeTablePermissions(this.employeeId)
      .pipe(
        finalize(() => {
          this.buildNavList();
          this.navigateToFirstAllowedSection();
        })
      )
      .subscribe(
        res => {
          this.targetEmployeeTablePermissions = res;
        }
      );
  }

  buildNavList() {
    this.navList = [
      {
        text: this.translate.instant('PersonalDetails'),
        localizationCode: 'PersonalDetails',
        subSection: 'PersonalDetails',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/PersonalDetails`,
        tableAccess: {
          tableId: db_tables.Talent,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      // {
      //   text: this.translate.instant('LeaveHistory'),
      //   localizationCode: 'LeaveHistory',
      //   subSection: 'LeaveHistory',
      //   link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/LeaveHistory`,
      //   module: modules.TIME_OFF,
      //   tableAccess: {
      //     tableId: db_tables.ABSENCES,
      //     permission: 'read',
      //     targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
      //   },
      // },
      // {
      //   text: this.translate.instant('ToilHistory'),
      //   localizationCode: 'ToilHistory',
      //   subSection: 'ToilHistory',
      //   link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/ToilHistory`,
      //   module: modules.TOIL,
      //   tableAccess: {
      //     tableId: db_tables.TOIL,
      //     permission: 'read',
      //     targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
      //   },
      // },
      {
        text: this.translate.instant('Compensation'),
        localizationCode: 'Compensation',
        subSection: 'Compensation',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Compensation`,
        tableAccess: {
          tableId: db_tables.Compensation,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('OtherCompensation'),
        localizationCode: 'OtherCompensation',
        subSection: 'OtherCompensation',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/OtherCompensation`,
        tableAccess: {
          tableId: db_tables.OtherCompensations,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('EmploymentDetails'),
        localizationCode: 'EmploymentDetails',
        subSection: 'EmploymentDetails',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/EmploymentDetails`,
        tableAccess: {
          tableId: db_tables.EmploymentDetails,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('EmergencyContacts'),
        localizationCode: 'EmergencyContacts',
        subSection: 'EmergencyContacts',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/EmergencyContacts`,
        tableAccess: {
          tableId: db_tables.EmergencyContacts,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('FamilyDependants'),
        localizationCode: 'FamilyDependants',
        subSection: 'FamilyDependants',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/FamilyDependants`,
        tableAccess: {
          tableId: db_tables.Family,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('MedicalTests'),
        localizationCode: 'MedicalTests',
        subSection: 'MedicalTests',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/MedicalTests`,
        tableAccess: {
          tableId: db_tables.MedicalTestings,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('VisaPermits'),
        localizationCode: 'VisaPermits',
        subSection: 'VisaPermits',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/VisaPermits`,
        tableAccess: {
          tableId: db_tables.VisaPermits,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Languages'),
        localizationCode: 'Languages',
        subSection: 'Languages',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Languages`,
        tableAccess: {
          tableId: db_tables.Languages,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Disciplines'),
        localizationCode: 'Disciplines',
        subSection: 'Disciplines',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Disciplines`,
        tableAccess: {
          tableId: db_tables.Disciplines,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('TrainingAndCertifications'),
        localizationCode: 'TrainingAndCertifications',
        subSection: 'TrainingAndCertifications',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/TrainingAndCertifications`,
        tableAccess: {
          tableId: db_tables.TrainingAndCertifications,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Education'),
        localizationCode: 'Education',
        subSection: 'Education',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Education`,
        tableAccess: {
          tableId: db_tables.Education,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('WorkExperiences'),
        localizationCode: 'WorkExperiences',
        subSection: 'WorkExperiences',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/WorkExperiences`,
        tableAccess: {
          tableId: db_tables.WorkExperiences,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('ProfessionalExpertises'),
        localizationCode: 'ProfessionalExpertises',
        subSection: 'ProfessionalExpertises',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/ProfessionalExpertises`,
        tableAccess: {
          tableId: db_tables.ProfessionalExpertises,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Associations'),
        localizationCode: 'Associations',
        subSection: 'Associations',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Associations`,
        tableAccess: {
          tableId: db_tables.Associations,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Documents'),
        localizationCode: 'Documents',
        subSection: 'Documents',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Documents`,
        tableAccess: {
          tableId: db_tables.DocumentLibrary,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('ProfileImage'),
        localizationCode: 'ProfileImage',
        subSection: 'ProfileImage',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/ProfileImage`,
        tableAccess: {
          tableId: db_tables.ProfilePictures,
          permission: 'update',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Projects'),
        localizationCode: 'Projects',
        subSection: 'Projects',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Projects`,
        tableAccess: {
          tableId: db_tables.Projects,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('CompanyAssets'),
        localizationCode: 'CompanyAssets',
        subSection: 'CompanyAssets',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/CompanyAssets`,
        tableAccess: {
          tableId: db_tables.CompanyAssets,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Relocations'),
        localizationCode: 'Relocations',
        subSection: 'Relocations',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Relocations`,
        tableAccess: {
          tableId: db_tables.Relocations,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('Grievances'),
        localizationCode: 'Grievances',
        subSection: 'Grievances',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/Grievances`,
        tableAccess: {
          tableId: db_tables.Grievances,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('InjuryIllness'),
        localizationCode: 'InjuryIllness',
        subSection: 'InjuryIllness',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/InjuryIllness`,
        tableAccess: {
          tableId: db_tables.InjuryIllness,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('BankDetails'),
        localizationCode: 'BankDetails',
        subSection: 'BankDetails',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/BankDetails`,
        tableAccess: {
          tableId: db_tables.BankDetails,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('PayrollDetails'),
        localizationCode: 'PayrollDetails',
        subSection: 'PayrollDetails',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/PayrollDetails`,
        tableAccess: {
          tableId: db_tables.PayrollDetails,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('BackgroundChecks'),
        localizationCode: 'BackgroundChecks',
        subSection: 'BackgroundChecks',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/${routes.BACKGROUND_CHECKS}`,
        tableAccess: {
          tableId: db_tables.BackgroundChecks,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: this.translate.instant('IntegrationDetails'),
        localizationCode: 'IntegrationDetails',
        subSection: 'IntegrationDetails',
        link: `${routes.TALENT_TRACK}${routes.EDIT}/${this.employeeId}${routes.EMPLOYEE_DETAILS}/IntegrationDetails`,
        tableAccess: {
          tableId: db_tables.IntegrationDetails,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
    ];

    // this.navList.sort((a, b) => a.text.localeCompare(b.text));

    // If the client doesnt have access to a module remove it form the list
    this.navList = this.navList.filter(
      feature => {
        if (feature.module) {
          return this.moduleConfigurationService.hasModuleAccess(feature.module);
        }
        else {
          return true;
        }
      }
    )

    this.isLoading = false;
  }

  get sectionInUrl(): string {
    return this.location.path(true);
  }

  setSectionInUrl(subSection: string): void {
    this.location.replaceState(`TalentTrack/Edit/${this.employeeId}/EmployeeDetails/${subSection}`);
    this.subSection = subSection;
  }

  navigateToFirstAllowedSection() {
    this.navList.every(element => {
      let hasAccess = this.tablePermissionsService.hasReadPermission(element.tableAccess.tableId, this.targetEmployeeTablePermissions);

      if (hasAccess) {
        this.setSectionInUrl(element.subSection);
        return false; // Break the loop
      }
      return true; // Continue the loop
    });
  }
}